const store = {
    namespaced: true,
    state() {
        return {};
    },
    getters: {},
    mutations: {},
    actions: {
        sendGoogleEvent(context, dataLayerObject) {
            if (typeof dataLayer === 'undefined') return;
            try {
                dataLayer.push({ ecommerce: null, user: null });
                dataLayer.push(dataLayerObject);
                console.log('EVENT', dataLayer);
            } catch (e) {
                console.error(e);
            }
        },

        sendItemViewEvent({ dispatch }, product) {
            if (!product) return;

            dispatch('sendGoogleEvent', {
                event: 'view_item',
                ecommerce: product
            });
        },

        sendItemWishlist({ dispatch }, product) {
            if (!product) return;

            dispatch('sendGoogleEvent', {
                event: 'add_to_wishlist',
                ecommerce: product
            });
        },

        sendItemAddToCartEvent({ dispatch }, product) {
            if (!product) return;

            dispatch('sendGoogleEvent', {
                event: 'add_to_cart',
                ecommerce: product
            });
        },

        sendItemDeleteFromCartEvent({ dispatch }, product) {
            if (!product) return;

            dispatch('sendGoogleEvent', {
                event: 'remove_from_cart',
                ecommerce: product
            });
        },

        sendCartBeginCheckoutEvent({ dispatch }, cart) {
            dispatch('sendGoogleEvent', {
                event: 'begin_checkout',
                ecommerce: cart
            });
        },

        sendCartPurchaseEvent({ dispatch }, data) {
            dispatch('sendGoogleEvent', {
                event: 'purchase',
                ecommerce: data.cart,
                user: data?.user
            });
        }
    }
};

export default store;
